import React from "react"
import IcoMoon from "react-icomoon"


// see react-icomoon docs https://www.npmjs.com/package/react-icomoon
const icoMoonWrapper = (selection) => {
  return ({ ...props }) => {
    return <IcoMoon iconSet={selection} {...props} />
  }
}

 
export default icoMoonWrapper